module.exports = __webpack_public_path__ + "static/entelo-cover-25a8ec78d6304162d06042a75bdb88b3.jpg";